import TokenBasedAuth from './TokenBasedAuth';

class Samsung extends TokenBasedAuth {
    constructor(props) {
        super(props, 'samsung');
    }
}

export default Samsung;
